import { SharedParams } from './shared-params.const';

const TraineCourseService = '/course-student';

// Controllers:
const TraineeCourseController = `${TraineCourseService}/trainees/courses/`;
const EnrollmentController = `${TraineCourseService}/enrollments/`;
const FavoriteController = `${TraineCourseService}/favorites/`;
const TraineeLearningPathController = `${TraineCourseService}/trainees/learning-paths`;
const TraineeProgressController = `${TraineCourseService}/trainees/progress`;
const TraineeController = `${TraineCourseService}/trainees/`;
const TraineeVoteController = `${TraineCourseService}/trainees/votes/`;
const NominationPermissionsController = `${TraineCourseService}/nomination/permissions/`;
const TrainingPlanController = `${TraineCourseService}/training-plan`;

export const TraineeCourse = {
  TraineeCourse: {
    Controller: TraineeCourseController,
    TraineeCoursesProfile: `${TraineeCourseController}my-space`,
    TraineeCoursesDetails: `${TraineeCourseController}trainee-courses-details`,
    CourseTrainees: (courseId: number) => `${TraineeCourseController}${courseId}/course-trainees`,
    TraineeEnrolledCourse: (courseId: number) => `${TraineeCourseController}${courseId}/trainee-enrolled-course`,
    CourseTraineesNomination: (courseId: number) => `${TraineeCourseController}${courseId}/course-trainees-nomination`,
    CourseEnrollment: (courseId: number) => `${TraineeCourseController}${courseId}/course-enrollment`,
    TraineeCount: `${TraineeCourseController}trainees-count`,
    DeclassifyGroupFromCourse: (courseId: number, groupId: Number) => `${TraineeCourseController}${courseId}/groups/${groupId}/group-declassifying`,
    DisconnectTraineeFromCourse: (courseId: number, traineeId: Number) => `${TraineeCourseController}${courseId}/trainees/${traineeId}/trainee-disconnect-course`,
    InitializingTraineeCourse: (traineeCourseId: number) => `${TraineeCourseController}${traineeCourseId}/initializing-trainee-course`,
    TraineePendingCourses: `${TraineeCourseController}trainee-pending-courses`,
    ChangeTraineeCourseAssignState: (courseId: number) => `${TraineeCourseController}${courseId}/trainee-assigning-${SharedParams.Status}`,
    RemainingSeats: (courseId: number) => `${TraineeCourseController}${courseId}/remaining-seats`,
    PreLearningPathCourses: (courseId: number) => `${TraineeCourseController}${courseId}/learning-paths/required-courses`,
  },
  NominationPermissions:
  {
    Permissions: NominationPermissionsController,
    UserPermissions: (userId) => `${NominationPermissionsController}user/${userId}`,
  },
  Enrollment: {
    EnrollmentsController: EnrollmentController,
    CourseEnrolledTrainees: (courseId: number) => `${EnrollmentController}${courseId}/course-enrolled-trainees`,
    ExportingCourseEnrollments: (courseId: number) => `${EnrollmentController}${courseId}/{Exporting}-course-enrollments`,
    TraineeEnrollments: (traineeId: number) => `${EnrollmentController}${traineeId}/trainee-courses`,
    ExportTraineeEnrollments: (traineeId: number) => `${EnrollmentController}${traineeId}/export-trainee-enrolled-courses`,

    TraineesByReferenceTypeAndReferenceId: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/trainees/${referenceId}`,
    PendingCoursesByReferenceTypePerTrainee: (referenceType: any) => `${EnrollmentController}${referenceType}/pending-courses`,
    AssignTrainee: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/${referenceId}/trainee-assign`,
    DeclassifyTrainee: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/${referenceId}/trainee-declassify`,
    ApprovementTrainee: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/${referenceId}/trainee-approvement`,
    JoinTrainee: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/${referenceId}/trainee-Joining`,
    EnrollmentApprovement: (referenceType: any, referenceId: Number) => `${EnrollmentController}${referenceType}/${referenceId}/enrollment-approvement`,
    NominationApprovement: (referenceType: any, referenceId: Number, approved: boolean) =>
      `${EnrollmentController}${referenceType}/${referenceId}/nomination-approvement?approved=${approved}`,
  },
  Favorite: {
    FavoritesController: FavoriteController,
    TraineeFavoriteCourse: (courseId: number) => `${FavoriteController}${courseId}`,
    RemoveFavoriteCourse: (favoriteCourseId: number) => `${FavoriteController}${favoriteCourseId}`,
  },
  TraineeLearningPath: {
    TraineeLearningPathsController: TraineeLearningPathController,
    TraineeJoiningLearningPathChecking: (learningPathId: number) => `${TraineeLearningPathController}/${learningPathId}/trainee-enrollee`,
    TraineeJoiningLearningPath: (learningPathId: number) => `${TraineeLearningPathController}/${learningPathId}/trainee-joining`,
    AssignTraineeToLearningPath: (learningPathId: number) => `${TraineeLearningPathController}/${learningPathId}/directing-trainee`,
    LearningPathTrainees: (learningPathId: number) => `${TraineeLearningPathController}/${learningPathId}/trainees`,
    TraineeDisconnectToLearningPath: (learningPathId: number, traineeId: number) => `${TraineeLearningPathController}/${learningPathId}/trainees/${traineeId}/disconnecting`,
    GetUpcommingDiploma: `${TraineeLearningPathController}/upcomming-diploma`
  },
  TraineeProgress: {
    TraineeProgressController: TraineeProgressController,
    TraineeCourseProgress: (courseId: number) => `${TraineeProgressController}/${courseId}`,
    TraineeCourseProgressDetails: (courseId: number) => `${TraineeProgressController}/${courseId}/details`,
    CurrentContentProgress: (courseId: number) => `${TraineeProgressController}/${courseId}/current-content-progress`,
    IncompleteCoursesContent: (courseId: number) => `${TraineeProgressController}/${courseId}/incomplete-content`,
    ContentProgress: (contentId: number) => `${TraineeProgressController}/content/${contentId}`,
    UpdateProgressTries: `${TraineeProgressController}/progress-tries`,
    WatchCourseContent: `${TraineeProgressController}/course-content-watching`,
    CourseExamAttempts: `${TraineeProgressController}/course-exam-attempts`,
    Sequence: `${TraineeProgressController}/sequence`,
    UpdateOnsiteSectionProgress: (sectionId: number) => `${TraineeProgressController}/${sectionId}/onsite-section`,
  },
  Trainee: {
    TraineesController: TraineeController,
    TraineeCanBeRemoved: (traineeId: number) => `${FavoriteController}${traineeId}`,
  },
  TraineeVote: {
    TraineeVotesController: TraineeVoteController,
    CheckStudentVote: (voteId: number) => `${TraineeVoteController}${voteId}/check-vote`,
  },
  TrainingPlan: {
    Controller: TrainingPlanController,
    GetList: TrainingPlanController,
    HomeStatus: `${TrainingPlanController}/create`,
    Delete: `${TrainingPlanController}/delete`,
    GetStudentPlans: `${TrainingPlanController}/student-plans`,
    TrainingPlanReport:(trainingPlanId: number) => `${TrainingPlanController}/${trainingPlanId}/student-plans-report?isStudent=true`,
    StartPoint:(trainingPlanId: number, skillId: number) => `${TrainingPlanController}/${trainingPlanId}/skill-start-point/${skillId}`,
    SubmitCompletionProof: (trainingPlanId: number, skillId: number) => `${TrainingPlanController}/${trainingPlanId}/skill/${skillId}/external-course-proof/upload`,
    ApprovementExternalProof: `${TrainingPlanController}/plan-course-proof/approvement`,
  }
};
